export default function Loader() {
  return <p className="text-gray-400">Loading...</p>;
}
